import {AbstractModel} from '../abstract-model';
import {Product} from '../product';
import {Gtm} from '../gtm';

export class Site extends AbstractModel {
  id: number | null = null;
  name: string | null = null;
  domain: string | null = null;
  url: string | null = null;
  enabled: boolean = true;
  companyName: string | null = null;
  companyAddress: string | null = null;
  companyPostalCode: string | null = null;
  companyCountry: string | null = null;
  companyRegistrationNumber: string | null = null;
  companyEuVatNumber: string | null = null;
  companyGbVatNumber: string | null = null;
  product: Product | null = null;
  partnerId: number | null = null;
  offerId: number | null = null;
  gtm: Gtm | null = null;
  contactEmail: string | null = null;
  dpoEmail: string | null = null;
  termsUrl: string | null = null;
  privacyUrl: string | null = null;
  cookieUrl: string | null = null;
  contactUrl: string | null = null;
  privacyContent: string | null = null;
  termsContent: string | null = null;
  privacyUpdatedAt: Date | null = null;
  termsUpdatedAt: Date | null = null;
  lang: string | null = null;
  productP2: string | null = null;
  productP2Alt: string | null = null;
  productCross: string | null = null;
  productSlide: string | null = null;
  productP2Gdpr: string | null = null;
  productP2AltGdpr: string | null = null;
  productCrossGdpr: string | null = null;
  productSlideGdpr: string | null = null;
  status: string | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    if (input.gtm) {
      this.gtm = new Gtm().deserialize(input.gtm);
    }

    return this;
  }

  override toString(): string {
    return this.name ?? '';
  }
}
